import {BsSearch,BsStar,BsFillStarFill,BsTrashFill,BsBanFill,BsCheckSquareFill } from 'react-icons/bs'
import {useDashData} from '../Contexts/DashboardDataContext';
import {useState, useRef} from 'react'
import {doc, updateDoc} from 'firebase/firestore';
import { FBDataBase } from '../Firebase/firebase';
import PopUp from './PopUp';

const DashboardResidents = (sidebarStatus) => {

    const [popUpActive, setPopUpActive] = useState(false)
    const [denyPopUpActive, setDenyPopUpActive] = useState(false)
    const [searchQuery,setSearchQuery] = useState("")
    const relevantUser = useRef();

    const [adminPopUpActive, setAdminPopUpActive] = useState(false);
    const [removeAdminPopUpActive, setRemoveAdminPopUpActive] = useState(false)
    const selectedUser = useRef(null);
    
    const {residentsData, updateResident, toggleAdminStatus} = useDashData();
    const pendingResidents = residentsData.filter(user => (!user.approved && user.pending));
    const approvedResidents = residentsData.filter(user => user.approved);


    const cancelMakeAdmin = () => {
      selectedUser.current = null;
    }

    const removeUserConfirm = (userID) => {
      setPopUpActive(true)
      relevantUser.current = userID;

    }

    const denyUserConfirm = (userID) => {
      setDenyPopUpActive(true)
      relevantUser.current = userID;
    }

    const removeUser = async () => {
      try {
        const userRef = doc(FBDataBase, "users", relevantUser.current);
        await updateDoc(userRef, { approved: false, pending: false });
        console.log(`User ${relevantUser.current} removed successfully.`);
      } catch (error) {
          console.error("Error removing user:", error);
      }
    }

    const acceptUser = async (userID) => {
      try {
        await updateResident(userID, { approved: true, pending: false });
      } catch (error) {
        console.error("Error approving user:", error);
      }
    };
    
    const denyUser = async () => {
      try {
        await updateResident(relevantUser.current, { approved: false, pending: false });
      } catch (error) {
        console.error("Error denying user:", error);
      }
    };
    


  const formatPhoneNumber = (phoneArray) => {
      if (Array.isArray(phoneArray) && phoneArray.length === 3) {
          return `${phoneArray[0]}-${phoneArray[1]}-${phoneArray[2]}`;
      }
      return phoneArray; // Return as-is if not in expected format
  };

  

    // Filter approvedResidents based on search query
    const filteredResidents = approvedResidents.filter(user => {
        const query = searchQuery.toLowerCase();
        const phoneStr = user.phoneNumber ? String(user.phoneNumber).replace(/\D/g, '') : ''; // Ensure phoneNumber is a string
    
        return (
            user.name.toLowerCase().includes(query) || phoneStr.includes(query)
        );
    });

    return(
        <div className="dashboard-table-page">
            <section className="dash-card dashboard-table-card">
            <div className="table-toolbar">
                    <div className="search-box">
                        <BsSearch style={{fontSize: "1.2rem"}}/>
                        <input value={searchQuery} onChange={(e)=>setSearchQuery(e.target.value)} type="text" placeholder="Search residents"></input>
                    </div>
                    {/* <div style={{width: 100}}></div>
                        <div className="green-button" style={{borderRadius: 4, padding: 8, display:"flex",flexDirection:"row"}}>
                            <BsPlusCircle style={{fontSize:"1.2rem"}}/>
                            <div style={{width: 4}} />
                            <div style={{fontSize:"1rem"}}>create resident</div>
                        </div> */}
                </div>
  <h2 className="table-section-title">Pending confirmation</h2>
  <table className="styled-table">
    <thead>
      <tr>
        <th>Name</th>
        <th>Address</th>
        <th>Email</th>
        <th>Phone #</th>
        <th style={{width:"5rem"}}></th>
      </tr>
    </thead>
    <tbody>
          {pendingResidents.length > 0 ? (
            pendingResidents.map((user) => (
              <tr key={user.id}>
                <td>{user.name || "N/A"}</td>
                <td>{user.address || "N/A"}</td>
                <td>{user.email || "N/A"}</td>
                <td>{formatPhoneNumber(user.phoneNumber) || "N/A"}</td>
                <td style={{flexDirection:"row",display:"flex", justifyContent:"space-evenly"}}>

                  <div className='clickable' onClick={() => acceptUser(user.id)}>
                    <BsCheckSquareFill size={"1.2rem"} color={"green"}/>
                  </div>
                  <div className='clickable' onClick={() => denyUserConfirm(user.id)}>
                    <BsBanFill size={"1.2rem"} color={"red"}/>
                  </div>
                  </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" style={{ textAlign: "center", padding: "10px" }}>
                No pending requests...
              </td>
            </tr>
          )}
        </tbody>
  </table>
  {!searchQuery ? (
    <>
    <h2 className="table-section-title">Confirmed residents</h2>
    <table className="styled-table">
      <thead>
        <tr>
          <th>Name</th>
          <th>Address</th>
          <th>Email</th>
          <th>Phone #</th>
          <th style={{width:"5rem"}}></th>
        </tr>
      </thead>
      <tbody>
            {approvedResidents.length > 0 ? (
              approvedResidents.map((user) => (
                <tr key={user.id}>
                  <td>
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center" }}>
                      {user.isAdmin ? (
                        <div
                          className="clickable"
                          style={{ marginRight: "5px" }}
                          onClick={() => {
                            selectedUser.current = user;
                            setRemoveAdminPopUpActive(true);
                          }}
                        >
                          <BsFillStarFill color="gold" title="Admin" />
                        </div>
                      ) : (
                        <div
                          className="clickable"
                          style={{ marginRight: "5px" }}
                          onClick={() => {
                            selectedUser.current = user;
                            setAdminPopUpActive(true);
                          }}
                        >
                          <BsStar color="gray" title="Make Admin" />
                        </div>
                      )}
                      {user.name || "N/A"}
                    </div>
                  </td>
                  <td>{user.address || "N/A"}</td>
                  <td>{user.email || "N/A"}</td>
                  <td>{formatPhoneNumber(user.phoneNumber) || "N/A"}</td>
                  <td style={{flexDirection:"row",display:"flex", justifyContent:"space-evenly"}}>
                    {/* <div className="clickable" onClick={modifyUser(user.id)}>
                      <BsGearFill color={"blue"}/>
                    </div> */}
                    <div className='clickable' onClick={()=>removeUserConfirm(user.id)}>
                      <BsTrashFill size={"1.2rem"} color={"red"}/>
                    </div>
                    </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" style={{ textAlign: "center", padding: "10px" }}>
                  No residents found
                </td>
              </tr>
            )}
          </tbody>
    </table>
    </>
  ) : (
    <>
    <h2 className="table-section-title">Matching residents</h2>
    <table className="styled-table">
      <thead>
        <tr>
          <th>Name</th>
          <th>Address</th>
          <th>Email</th>
          <th>Phone #</th>
          <th style={{width:"5rem"}}></th>
        </tr>
      </thead>
      <tbody>
            {filteredResidents.length > 0 ? (
              filteredResidents.map((user) => (
                <tr key={user.id}>
                  <td>
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center" }}>
                      {user.isAdmin ? (
                        <div
                          className="clickable"
                          style={{ marginRight: "5px" }}
                          onClick={() => {
                            selectedUser.current = user;
                            setRemoveAdminPopUpActive(true);
                          }}
                        >
                          <BsFillStarFill color="gold" title="Admin" />
                        </div>
                      ) : (
                        <div
                          className="clickable"
                          style={{ marginRight: "5px" }}
                          onClick={() => {
                            selectedUser.current = user;
                            setAdminPopUpActive(true);
                          }}
                        >
                          <BsStar color="gray" title="Make Admin" />
                        </div>
                      )}
                      {user.name || "N/A"}
                    </div>
                  </td>
                  <td>{user.address || "N/A"}</td>
                  <td>{user.email || "N/A"}</td>
                  <td>{formatPhoneNumber(user.phoneNumber) || "N/A"}</td>
                  <td style={{flexDirection:"row",display:"flex", justifyContent:"space-evenly"}}>
                    {/* <div className="clickable" onClick={modifyUser(user.id)}>
                      <BsGearFill color={"blue"}/>
                    </div> */}
                    <div className='clickable' onClick={()=>removeUserConfirm(user.id)}>
                      <BsTrashFill size={"1.2rem"} color={"red"}/>
                    </div>
                    </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" style={{ textAlign: "center", padding: "10px" }}>
                  No matching residents found
                </td>
              </tr>
            )}
          </tbody>
    </table>
    </>
  )}
  


            </section>
            {popUpActive && <PopUp setPopUpActive={setPopUpActive} message={"Are you sure you want to remove this resident?"} action={removeUser} type={"confirm"}/>}
            {denyPopUpActive && <PopUp setPopUpActive={setDenyPopUpActive} message={"Are you sure you want to deny this resident?"} action={denyUser} type={"confirm"} />}
            {adminPopUpActive && selectedUser.current && (
              <PopUp
                setPopUpActive={setAdminPopUpActive}
                message={`Make ${selectedUser.current.name} an admin?`}
                action={() => {
                  toggleAdminStatus(selectedUser.current.id, selectedUser.current.isAdmin);
                }}
                cancel={cancelMakeAdmin}
                type="confirm"
              />
            )}
            {removeAdminPopUpActive && selectedUser.current && (
              <PopUp
                setPopUpActive={setRemoveAdminPopUpActive}
                message={`Revoke ${selectedUser.current.name}'s admin status?`}
                action={() => {
                  toggleAdminStatus(selectedUser.current.id, selectedUser.current.isAdmin);
                }}
                cancel={cancelMakeAdmin}
                type="confirm"
              />
            )}
        </div>
    )
}

export default DashboardResidents
